import { forwardRef } from 'react';
import styled, { ThemeProvider, useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMobilePanelBody = styled.div.withConfig({
  displayName: "MobilePanelBody__StyledMobilePanelBody",
  componentId: "p0yfme-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    flex: '1 1 auto',
    minHeight: 'auto',
    overflow: 'auto',
    padding: theme.space['0'],
    position: 'relative'
  };
});
const MobilePanelBody = /*#__PURE__*/forwardRef(({
  children
}, ref) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(StyledMobilePanelBody, {
      ref: ref,
      children: children
    })
  });
});
export default MobilePanelBody;